import ResetButton from "./reset-button";
import ApplyButton from "./apply-button";
import Content from "./content";
import Header from "./header";
import Body from "./body";
import Root from "./root";

export const Popover = {
    Root,
    Header,
    Body,
    Content,
    ResetButton,
    ApplyButton,
};
